/**
 * AlphaCore brand mark.
 * Uses the official raster logo (rainbow α emblem) + AlphaCore wordmark.
 * `variant`:
 *   - "inline"  → mark + wordmark, horizontal (used in navs, headers)
 *   - "mark"    → mark only, square
 *   - "hero"    → large centered mark with pedestal glow (auth splash / landing feature)
 */
const LOGO_SRC = "/brand/alphacore-logo.png";

export const AlphaCoreLogo = ({ size = 34, variant = "inline", className = "" }) => {
  if (variant === "hero") {
    const s = size;
    return (
      <div
        className={`relative inline-block ${className}`}
        style={{ width: s, height: s }}
        data-testid="alphacore-logo"
      >
        <div
          className="absolute inset-0 rounded-full pointer-events-none"
          style={{
            background:
              "conic-gradient(from 180deg, rgba(255,58,168,0.28), rgba(122,90,255,0.28), rgba(58,180,255,0.28), rgba(0,255,140,0.24), rgba(255,178,0,0.28), rgba(255,58,168,0.28))",
            filter: "blur(48px)",
          }}
        />
        <div
          className="absolute inset-0 rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(255,255,255,0.10), transparent 60%)", filter: "blur(18px)" }}
        />
        <img
          src={LOGO_SRC}
          alt="AlphaCore"
          className="relative w-full h-full object-contain select-none"
          draggable={false}
        />
      </div>
    );
  }

  const wordmark = variant !== "mark";
  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`} data-testid="alphacore-logo">
      <div className="relative shrink-0" style={{ width: size, height: size }}>
        <div
          className="absolute inset-0 rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, rgba(255,58,168,0.20), transparent 65%)", filter: "blur(8px)" }}
        />
        <img
          src={LOGO_SRC}
          alt=""
          aria-hidden
          className="relative w-full h-full object-contain select-none"
          draggable={false}
        />
      </div>
      {wordmark && (
        <div className="leading-none">
          <div className="font-display font-bold tracking-tighter text-[15px] leading-none text-white">
            AlphaCore
          </div>
          <div
            className="mt-1 kr-overline text-[8.5px] leading-none tracking-[0.18em]"
            style={{ background: "linear-gradient(90deg,#FF3AA8,#FF8A22,#FFD23F)", WebkitBackgroundClip: "text", backgroundClip: "text", color: "transparent" }}
          >
            The Core of Intelligence
          </div>
        </div>
      )}
    </div>
  );
};

export const KARRAR_LOGO_INLINE = LOGO_SRC;  // kept for backwards-compat import
export const KARRAR_LOGO_HERO = LOGO_SRC;
export default AlphaCoreLogo;
